






import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import moment from 'moment'
import { MAX_RECORDS_DURATION } from '@/constants/dataTable'

interface Computed {
  recordDuration: string
}

interface Props {
  columnValue: number
  columnName: string
  directory: string
}

export default mixins(WindowResizeListener).extend<{}, {}, Computed, Props>({
  props: {
    columnValue: {
      required: true,
    },
    columnName: {
      required: true,
    },
    directory: {
      required: true
    }
  },
  computed: {
    recordDuration(): string {
      if (this.columnValue < MAX_RECORDS_DURATION) {
        return moment
          .utc(this.columnValue * 1000)
          .local()
          .format('HH:mm:ss')
      }
      return this.$tc('records.moreThen5Hours')
    },
  },
})
